import { WorkSchedule } from '@/resources/enterprise/Enterprise';
import { BusinessType, History, Invoice, Town } from '@/store/types/work/invoice';
import { PositionModel } from '@/store/types/work/Positions';

export interface location {
  latitude: string,
  longitude: string
}

export interface Provider {
  id: number
  debt: number
  title: string,
  town?: Town,
  address: string,
  business_type?: BusinessType,
  data: {
    contact_person?: {
      name: string,
      last_name: string,
      phone: string
    },
    enterprise?: {
      business_type_id: number,
      town_id: number,
      building: string,
      street: string,
      location?: location
    }
    work_schedule?: WorkSchedule
  },
  price_type: number|null,
  note: string,
  manager?: PositionModel
  manager_id?: number,
  log?: History[],
  last_outgoing_invoice?: Invoice
  created_at?:string
  updated_at?:string
}

export class ProviderModel implements Provider {
  address: string = '';
  debt: number = 0;
  data: {
    contact_person?:
      { name: string; last_name: string; phone: string };
    enterprise?: { business_type_id: number; town_id: number; building: string; street: string, location?: location };
    work_schedule?: WorkSchedule
  } = {};
  id: number = 0;
  note: string = '';
  price_type: number | null = null;
  title: string = '';
  created_at?: string = '';
  updated_at?: string = '';
  business_type?: BusinessType;
  manager?: PositionModel;
  manager_id?: number;
  town?: Town;
  last_outgoing_invoice?: Invoice;
  log?: History[]

  constructor (data?: Provider) {
    if (data) {
      this.address = data.address;
      this.data = data.data;
      this.id = data.id;
      this.debt = data.debt;
      this.note = data.note;
      this.town = data.town;
      this.price_type = data.price_type;
      this.title = data.title;
      this.business_type = data.business_type;
      this.business_type = data.business_type;
      this.manager = data.manager ? new PositionModel(data.manager) : undefined;
      this.manager_id = data.manager_id;
      this.log = data.log;
      this.created_at = data.created_at;
      this.updated_at = data.updated_at;
      this.log = data.log;
      this.last_outgoing_invoice = data.last_outgoing_invoice;
    }
  }

  get getAddress () {
    let address = '';
    if (this.data.enterprise) {
      address = this.data.enterprise.street + ' ' + this.data.enterprise.building;
    } else address = this.address;
    return this.getTown + ' ' + address;
  }

  get getTown () {
    return this.town
      ? (this.town.district ? this.town.district + ' район, ' : '') + this.town.title
      : '';
  }

  get getLocation () {
    if (this.data.enterprise && this.data.enterprise.location) {
      const location = this.data.enterprise.location;
      return { latitude: parseFloat(location.latitude), longitude: parseFloat(location.longitude) };
    }
    return {};
  }
}

export class CustomerModel extends ProviderModel {}
